import apiClient from './apiClient';

export interface PostSearchSurveyAnswers {
  did_help_goal: string;
  follow_up_feedback?: string | null;
  disliked: string[];
  disliked_other_feedback?: string | null;
  would_pay_for: string[];
  would_pay_for_other_feedback?: string | null;
  additional_feedback: string | null;
}

export const completePostSearchSurvey = (answers: PostSearchSurveyAnswers) =>
  apiClient.post<{ post_search_survey_completed: boolean }>('/post-search-survey/complete', answers);
